import React from 'react';
import PropTypes from 'prop-types';
import {FilterGroups} from '~/GalleryPB/FilterGroups';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';

export const FiltersDrawer = (props) => {
  const {handleCancelClick, handleApplyClick, onFilterToggle, filters, onPremiumInfoClick} = props;

  return (
    <>
      <div
        className={`gallery__filters-sidebar ${props.open ? 'open' : ''}`}
        data-qa-id="galleryFiltersDrawer"
      >
        <div className="gallery__filters-drawer__main-content-wrapper">
          <div className="gallery__filters-drawer__header">
            <Typography variant="header1" as="h2">
              Filter
            </Typography>
            <Button
              variant="transparent"
              size="small"
              data-qa-id="galleryFiltersDrawerCloseButton"
              onClick={() => handleApplyClick()}
            >
              <CloseLineIcon />
            </Button>
          </div>
          <div className="gallery__filters-drawer__filter-groups-wrapper">
            <FilterGroups
              filters={filters}
              onFilterToggle={onFilterToggle}
              onPremiumInfoClick={onPremiumInfoClick}
            />
          </div>
          <div className="gallery__filters-drawer__filters-bottom-fade" />
        </div>
        <div className="gallery__filters-drawer__cta-group">
          <div className="button-group--expand">
            <Button
              size="large"
              variant="secondary"
              className="button-group-item"
              data-qa-id="galleryFiltersDrawerCancelChangesButton"
              onClick={handleCancelClick}
            >
              Cancel
            </Button>
            <Button
              size="large"
              variant="primary"
              className="button-group-item"
              data-qa-id="galleryFiltersDrawerApplyChangesButton"
              onClick={() => handleApplyClick()}
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
      <div
        onClick={() => handleApplyClick()}
        className={`gallery__filters-overlay ${props.open ? 'open' : ''}`}
        data-qa-id="galleryFiltersDrawerOverlay"
      />
    </>
  );
};

FiltersDrawer.propTypes = {
  handleCancelClick: PropTypes.func,
  handleApplyClick: PropTypes.func,
  onFilterToggle: PropTypes.func,
  filters: PropTypes.object.isRequired,
  onPremiumInfoClick: PropTypes.func,
};
